import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { BatchStatus } from '@services/cleanfill-api/cleanfill-api.generated';

@Directive({
  selector: '[colorBatchStatus]'
})
export class ColorBatchStatusDirective implements OnChanges {
  @Input() status: BatchStatus;
  prevColorClass: string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.status = null;
    this.prevColorClass = '';
  }

  ngOnChanges(): void {
    this.onStatusChange(this.status);
  }

  private onStatusChange(status: BatchStatus): void {
    this.prevColorClass = this.status;

    //  TODO: Add other colors as design requirements beecome available
    switch (status) {
      case BatchStatus.Approved:
        this.setHostElementClass('approved');
        break;
      case BatchStatus.Complete:
        this.setHostElementClass('complete');
        break;
      case BatchStatus.Draft:
        this.setHostElementClass('draft');
        break;
      case BatchStatus.Inprogress:
        this.setHostElementClass('inprogress');
        break;
      case BatchStatus.FillSitePending:
        this.setHostElementClass('pending');
        break;
      case BatchStatus.FillSiteRejected:
        this.setHostElementClass('rejected');
        break;

      default:
        this.setHostElementClass('default');
        break;
    }
  }

  private setHostElementClass(colorClass: string) {
    if (this.prevColorClass) {
      this.renderer.removeClass(this.elementRef.nativeElement, this.prevColorClass);
    }

    this.renderer.addClass(this.elementRef.nativeElement, colorClass);
  }
}
